<template>
  <v-clamp
    v-tooltip="{ content: text, theme: 'overflow', shown: showTooltip && localClamped }"
    autoresize
    :expanded="expand"
    :max-lines="maxLines"
    v-bind="$attrs"
    @clampchange="onClamped($event)"
    @update:expanded="onExpanded($event)"
    v-on="$listeners"
  >
    <slot></slot>
    <template #after="{ clamped, expanded, toggle }">
      <v-btn
        v-if="!tooltip && (clamped || expanded)"
        x-small
        text
        @click.stop="onToggle({ clamped, expanded, toggle })"
      >
        {{ clamped ? $t('ui.more') : $t('ui.less') }}
      </v-btn>
    </template>
  </v-clamp>
</template>

<script>
/*
 * Three modes:
 * 1. More/Less button.
 * 2. Hover to expand.
 * 3. Tooltips.
 */
import VClamp from 'vue-clamp'

export default {
  name: 'ClampedText',

  components: {
    'v-clamp': VClamp
  },

  props: {
    expand: {
      // initial expanded state
      type: Boolean,
      required: false,
      default: false
    },

    maxLines: {
      // maximum lines before clamping occurs
      type: Number,
      required: false,
      default: 3
    },

    tooltip: {
      // use tooltips (vs. clamping)
      type: Boolean,
      required: false,
      default: false
    }
  },

  data: function () {
    return {
      localClamped: false,
      mouseover: false
    }
  },

  computed: {
    showTooltip() {
      return this.tooltip && this.mouseover
    },

    text() {
      return this.$slots.default
        ? this.$slots.default
            .map((vnode) => vnode.children || vnode.text)
            .join('')
            .trim()
        : ''
    }
  },

  mounted() {
    if (this.tooltip) {
      this.$el.addEventListener('mouseover', this.onMouseOver)
      this.$el.addEventListener('mouseout', this.onMouseOut)
    }
  },

  beforeDestroy() {
    if (this.tooltip) {
      this.$el.removeEventListener('mouseover', this.onMouseOver)
      this.$el.removeEventListener('mouseout', this.onMouseOut)
    }
  },

  methods: {
    onMouseOver() {
      this.mouseover = true
    },

    onMouseOut() {
      this.mouseover = false
    },

    onClamped(clamped) {
      this.localClamped = clamped
      this.$emit('clamped', clamped)
    },

    onExpanded(expanded) {
      this.$emit('expanded', expanded)
    },

    onToggle({ clamped, expanded, toggle }) {
      if (!this.tooltip) {
        toggle()
        this.localClamped = !clamped
        this.$emit('expanded', !expanded) // "expanded" is pre-toggle
      }
    }
  }
}
</script>

<style lang="css" scoped>
.c-clamp {
  display: -webkit-box;
  line-clamp: 3;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
}
.c-tooltip {
  max-width: 300px;
  font-size: 1rem;
  line-height: 1.5;
  padding: 8px;
  word-break: break-word;
  white-space: pre-wrap;
}
</style>

